import { IFolder } from '@/folders/types/folder';

export interface IFoldersState {
  loading: boolean;
  loaded: boolean;
  folders: IFolder[];
  breadcrumbs: IFolder[];
}

export enum EFolderAction {
  Load = 'load',
  LoadSucces = 'loadSuccess',
  LoadFailed = 'loadFailed',

  Create = 'create',
  CreateSuccess = 'createSuccess',

  Update = 'update',
  UpdateSuccess = 'updateSuccess',

  Delete = 'delete',
  DeleteSuccess = 'deleteSuccess',

  Reset = 'reset',
}

export enum EFolderMutation {
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetFolders = 'setFolders',
  SetBreadcrumbs = 'setBreadcrumbs',
  SetState = 'setState',
}
